module.exports = __webpack_public_path__ + "img/features-bg_13.578bb0bf.png";